import { useApiClient } from '@/composables/useApiClient'

import type { IApiListResponse } from './interfaces/api-list-response.interface'
import type { ICreateHubContactRequest } from './interfaces/create-hub-contact-request.interface'
import type { IExtensionContact } from './interfaces/extension-contact.interface'
import type { IHubContact } from './interfaces/hub-contact.interface'
import type { IUpdateHubContactRequest } from './interfaces/update-hub-contact-request.interface'

export interface IContactListFilters {
  page?: number
  size?: number
  search?: string
  sort?: string
  direction?: 'asc' | 'desc'
  status?: 'ACTIVE' | 'INACTIVE'
}

export const useContactService = () => {
  const privateApi = useApiClient(true)

  const getHubContacts = async (filters?: IContactListFilters) => {
    return privateApi.get<IApiListResponse<IHubContact>>('/contacts', { params: filters })
  }

  const createHubContact = async (data: ICreateHubContactRequest) => {
    return privateApi.post<IHubContact, ICreateHubContactRequest>('/contacts', data)
  }

  const updateHubContact = async (contactId: string, data: IUpdateHubContactRequest) => {
    return privateApi.patch<IHubContact, IUpdateHubContactRequest>(`/contacts/${contactId}`, data)
  }

  const deleteHubContact = async (contactId: string) => {
    return privateApi.delete<void>(`/contacts/${contactId}`)
  }

  const getExtensionContacts = async (filters?: IContactListFilters) => {
    return privateApi.get<IApiListResponse<IExtensionContact>>('/contacts/extensions', {
      params: filters,
    })
  }

  return {
    getHubContacts,
    createHubContact,
    updateHubContact,
    deleteHubContact,
    getExtensionContacts,
  }
}
